import React from 'react';
import styled from 'styled-components';
import { AvInput } from 'availity-mobx-reactstrap-validation';

export default styled(({ legend, cardType, ...rest }) => <AvInput {...rest} />)`
  background: ${({ legend, cardType }) =>
    legend !== false ? `url(/images/payment-icons/${cardType || 'creditcards'}.png) no-repeat right center` : 'white'};
  background-size: ${({ cardType }) => (cardType ? 'auto' : '140px')};
`;
